<template>
    <div class="standalone-product-widget-edit relative">
        <menu-item label="背景设置">
            <menu-fill :target="model.background" target-key="background" />
        </menu-item>
        <menu-item label="文字色">
            <menu-fill :target="model.mainTextColor" solid-color target-key="mainTextColor" />
        </menu-item>
        <menu-item label="价格文字色">
            <menu-fill :target="model.priceTextColor" solid-color target-key="priceTextColor" />
        </menu-item>
        <menu-item label="价格背景色">
            <menu-fill :target="model.priceBackground" target-key="priceBackground" />
        </menu-item>
        <nav-edit class="mt-6" label="应用链接" :target="model.link" :site="site" />
        <menu-item label="按钮填充色">
            <menu-fill :target="model.buttonBackground" target-key="buttonBackground" />
        </menu-item>
        <menu-item label="按钮文字颜色">
            <menu-fill :target="model.buttonTextColor" solid-color target-key="buttonTextColor" />
        </menu-item>
    </div>
</template>

<script>
import NavEdit from '~/site/components/navEdit.vue'
import menuItem from '~/components/menu/menuItem.vue';
import menuFill from '~/components/menu/menuFill.vue';
export default {
    name: 'StandaloneProductWidgetEdit',
    components: {
        NavEdit,
        menuItem,
        menuFill
    },
    props: {
        site: Object,
        model: {
            type: Object,
            default: () => { }
        }
    }
}
</script>